export default class Widget {
  constructor(el, uuid) {
    this.el = el;
    this.uuid = uuid;
    this.hasExecuted = false;
  }

  // Takes the <script> src and formats it for the iframe
  formatUrlForIframe(url) {
    const qs = document.location.search;

    let formattedURL = url.replace('futuri-post-widget.js', 'futuri-post-widget.html');

    if (qs.length > 1) {
      if (formattedURL.indexOf('?') > 0) {
        formattedURL += qs.replace('?', '&');
      } else {
        formattedURL += qs;
      }
    }

    if (formattedURL.indexOf('?') > 0) {
      formattedURL += '&';
    } else {
      formattedURL += '?';
    }

    formattedURL += `src=${encodeURIComponent(document.location.href)}`;

    if (formattedURL.indexOf('smc') < 0 && formattedURL.indexOf('zone') >= 0) {
      // Copy the zone param to the smc param for proper streamlib use of smc parameter
      const smc = /zone=(\d+)/.exec(formattedURL);
      formattedURL += `&smc=${smc[1]}`;
    }

    return formattedURL;
  }

  // Creates and styles an iframe element based on its parent
  getNewIframeElement(parentElement, options) {
    const iframeElement = document.createElement('iframe');

    iframeElement.setAttribute('style', 'border: 0; padding: 0; margin: 0;');
    iframeElement.setAttribute('scrolling', 'no');

    let width = 0;
    let height = 0;

    // the 'True' is a python boolean string
    if (options.vertical && (options.vertical === 'True' || options.vertical === 'true')) {
      width = 320;
      height = 500;
    } else {
      // horizontal layout (default)
      if (options.full && (options.full === 'True' || options.full === 'true')) {
        width = Math.min(700, parentElement.offsetWidth);
        height = 624;
      } else {
        width = Math.min(700, parentElement.offsetWidth);
        height = 224;
      }
    }

    iframeElement.style.borderRadius = '5px';

    if (parentElement.offsetHeight > 50) {
      iframeElement.height = parentElement.offsetHeight;
    }

    window.addEventListener('resize', () => {
      iframeElement.width = Math.min(width, iframeElement.parentElement.offsetWidth);
    }, false);

    iframeElement.width = width;
    iframeElement.height = height;

    window.addEventListener('message', (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg && msg.type === 'resize' && msg.id === this.uuid) {
          iframeElement.height = msg.height;
          iframeElement.width = msg.width;
        }
      } catch (e) {
        // msg probably not for me
      }
    });

    return iframeElement;
  }

  // Handles any preprocessing needed and inserts iframe onto the page
  handleIframe() {
    const scriptTag = document.querySelector('script[src*="futuri-post-widget"]');
    const urlPrefix = scriptTag.src.split('?')[0];
    const query = this.el.dataset.config;
    const url = this.formatUrlForIframe(`${urlPrefix}?${query}`);
    const options = Object.fromEntries(new URLSearchParams(url).entries());
    const iframeElement = this.getNewIframeElement(this.el, options);
    iframeElement.src = url;
    iframeElement.name = this.uuid; // This becomes window.name inside the iframe
    iframeElement.allow = 'clipboard-write'; // to support 'copy to clipboard'
    this.el.appendChild(iframeElement);
  }

  // Sets up the widget and marks it as executed
  setupWidget() {
    this.handleIframe();
    this.hasExecuted = true;
  }
}



// WEBPACK FOOTER //
// ./src/classes/widget.js